import { render, staticRenderFns } from "./driver_page copy.vue?vue&type=template&id=d40b9164&scoped=true"
import script from "./driver_page copy.vue?vue&type=script&lang=js"
export * from "./driver_page copy.vue?vue&type=script&lang=js"
import style0 from "./driver_page copy.vue?vue&type=style&index=0&id=d40b9164&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40b9164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40b9164')) {
      api.createRecord('d40b9164', component.options)
    } else {
      api.reload('d40b9164', component.options)
    }
    module.hot.accept("./driver_page copy.vue?vue&type=template&id=d40b9164&scoped=true", function () {
      api.rerender('d40b9164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/driver/driver_page copy.vue"
export default component.exports